import styled from 'styled-components';
import { DebounceInput } from 'react-debounce-input';
import { container, flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_DARKER,
  FONT_WEIGHT_BOLD,
  GRAY_LIGHTER,
  FONT_SIZE_3,
  DANGER_COLOR,
} from '../../styles/variables';

export const Content = styled.div`
  ${({ noMargin }) => (noMargin ? null : container)}
  ${flexPosition('center', 'start')};
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;
  display: inline;
  margin-left: 0px;
  padding: ${({ noMargin }) => (noMargin ? '0px' : 'initial')};
  cursor: pointer;
`;

export const Row = styled.div`
  width: 100%;
`;

export const Header = styled.header`
  width: 100%;
  ${flexPosition('center', 'center')};
`;

export const CustomInput = styled(DebounceInput)`
  border: none;
  background-color: transparent;
  ${props =>
    fontStyle(
      props.fontcolor || GRAY_DARKER,
      props.fontSize || FONT_SIZE_3,
      props.fontWeight || FONT_WEIGHT_BOLD
    )}
  outline: none;
  border-bottom: ${props => (props.active ? `1px solid ${GRAY_LIGHTER}` : 'none')};
  padding-right: ${props => (props.active ? '5px' : '35px')};
  width: ${({ width }) => width || '300px'};
  height: ${({ height }) => height || '40px'};
  ${props =>
    props.error
      ? `
    border-bottom: 2px solid ${DANGER_COLOR};
  `
      : null}
  &::placeholder {
    ${props =>
      fontStyle(
        props.fontcolor || GRAY_DARKER,
        props.fontSize || FONT_SIZE_3,
        props.fontWeight || FONT_WEIGHT_BOLD
      )}
  }
`;



// WEBPACK FOOTER //
// ./src/components/EditableTitle/style.js